export enum UploadMediaType {
  Photos = 'photos',
  Videos = 'videos',
}
